"use client";

import { useI18n, Locale } from "@/lib/i18n";

const LANG_CODES: Locale[] = ["cz", "ru", "en"];

export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="flex items-center gap-1">
      {LANG_CODES.map((code) => (
        <button
          key={code}
          onClick={() => setLocale(code)}
          className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
            locale === code
              ? "bg-hf-primary-soft text-hf-primary border border-hf-primary/30"
              : "text-hf-faint hover:text-hf-ink border border-transparent"
          }`}
          aria-label={`Switch to ${code}`}
        >
          {t.lang[code]}
        </button>
      ))}
    </div>
  );
}
